export default "__VITE_ASSET__1eb7869a__"